import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toggleProduct } from "../actions/productActions";

const CardListStatus = ({
  match,
  title,
  reading,
  readingDate,
  unit,
  bgColour,
  colour,
  icon,
  status,
  product,
}) => {
  // const productId = match.params.id;
  // const [toggle, setToggle] = useState();
  // const dispatch = useDispatch();
  // const {
  //   title,
  //   reading,
  //   readingDate,
  //   unit,
  //   bgColour,
  //   colour,
  //   icon,
  //   status,
  //   product,
  // } = props;
  // useEffect(() => {
  //   console.log(toggle);
  //   if (product && toggle !== undefined) {
  //     const data = {
  //       _id: product._id,
  //       toggle,
  //     };
  //     console.log(data);
  //     dispatch(toggleProduct(data));
  //   } else {
  //     if (product && product.getsetStatus === "ON") {
  //       setToggle(true);
  //     } else {
  //       setToggle(false);
  //     }
  //   }
  // }, [toggle]);

  return (
    <div
      className={`tw-font-nunito tw-text-center tw-bg-gray-100 tw-py-3 tw-m-2 sm:tw-w-1/6 tw-w-4/5 
      tw-rounded-md tw-shadow-md tw-bg-${bgColour}-500 tw-text-${colour}`}
    >
      <Row className="tw-flex tw-justify-evenly tw-items-center tw-px-3">
        <Col
          xs={7}
          className="sm:tw-text-center tw-text-left sm:tw-text-xl tw-text-lg tw-font-bold"
        >
          {title}
        </Col>
        <Col xs={5}>
          <i className={`${icon} fa-lg`}></i>
        </Col>
      </Row>
      {reading && (
        <p className="sm:tw-text-2xl tw-text-xl tw-pt-3 tw-mb-0">
          {reading} {unit}
        </p>
      )}
      {readingDate && (
        <p className="sm:tw-text-xl tw-text-lg tw-px-3 tw-pt-3 tw-mb-0">
          {readingDate} {unit}
        </p>
      )}
      {}
      {product && product.getsetStatus && (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-3">
          {/* <div
            className={`md:tw-w-14 md:tw-h-7 tw-w-12 tw-h-6 tw-flex tw-items-center tw-rounded-full tw-p-1 tw-cursor-pointer ${
              product && product.getsetStatus === "ON"
                ? "tw-bg-green-200"
                : "tw-bg-red-200"
            }`}
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <div
              className={` md:tw-w-6 md:tw-h-6 tw-h-5 tw-w-5 tw-rounded-full tw-shadow-md tw-transform ${
                product && product.getsetStatus === "ON"
                  ? "tw-transform tw-translate-x-6 tw-bg-green-500"
                  : "tw-bg-red-500"
              }`}
            ></div>
          </div> */}
          <div
            className={` tw-text-4xl tw-font-extrabold tw-pt-3 tw-mb-0 ${
              product && product.getsetStatus === "ON"
                ? "tw-text-green-600"
                : "tw-text-red-600"
            }`}
          >
            {product.getsetStatus === "ON" ? "ON" : "OFF"}
          </div>
        </div>
      )}
    </div>
  );
};

export default CardListStatus;

//
// product.engineSpeedRPMOffset.min <
// product.engineSpeedRPM[product.engineSpeedRPM.length - 1] &&
// product.engineSpeedRPM[product.engineSpeedRPM.length - 1] <
// product.engineSpeedRPMOffset.max &&
